<template>
    <img v-if="src" :src="src" :alt="alt" />
    <img v-else class="default" src="//statics.affili.ir/storage/assets/logo/affili-signet-white.png" :alt="alt">
</template>

<script>
export default {
    name: 'ImageProfile',

    props: {
        src: {
            required: true,
        },
        alt: {
            default: '',
            type: String,
        },
        imgClass: {
            default: '',
            type: String,
        }
    }
}
</script>